import { Pipe, PipeTransform } from '@angular/core';
import { PipesHelperInterface } from '@core/interfaces';

@Pipe({
  name: 'searchSelect',
  standalone: false
})
export class SearchSelectPipe implements PipeTransform {
  transform(companies: PipesHelperInterface.ISearchSelectPipeData[], name: string): PipesHelperInterface.ISearchSelectPipeData[] {

    if (!name || typeof name !== 'string' || name.length < 2) {
      return companies;
    }

    name = name.toLowerCase();

    // let endpointFilterParam = (type == 'ssp' ? 'name' : 'endpoint');
    const endpointFilterParam = 'name';
    const filteredCompanies = companies.filter(company => {
      return company.name.toLowerCase().includes(name);
    });

    if (filteredCompanies.length) {
      return filteredCompanies;
    }

    const filteredByEndpoint = companies.filter(company => {
      const hasEndpoint = company.endpoints.find((endpoint) => {
        return (endpoint[endpointFilterParam].toLowerCase().includes(name)) || (endpoint.id.toString().includes(name));
      });

      if (hasEndpoint) {
        return true;
      }
      return false;
    });
    if (!filteredByEndpoint.length) {
      if (filteredCompanies.length) {
        return filteredCompanies;
      }
      return [];
    }

    const final = filteredByEndpoint.map((company) => {
      const filteredEndpoints = company.endpoints.filter((endpoint) => {
        return (endpoint[endpointFilterParam].toLowerCase().includes(name)) || (endpoint.id.toString().includes(name));
      });
      const newComp = { ...company };
      newComp.endpoints = filteredEndpoints;
      return newComp;
    });
    return final;
  }
}
